import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalUploadStatusComponent } from './global-upload-status.component';

@NgModule({
  declarations: [
    GlobalUploadStatusComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GlobalUploadStatusComponent
  ]
})
export class GlobalUploadStatusModule { }
